/* Page content and destinations. The artwork itself is configured in gallery-config.js. */
window.VIULET_PRODUCT_PAGE = {
  id: 'letters-to-the-subconscious',
  title: 'Letters to the Subconscious',
  artist: 'Benjamin Viulet',
  editionLabel: 'The Remastered Edition · Signed & numbered',
  // Uses the same temporary pricing as the approved configurator until Shopify supplies a quote.
  currency: 'USD',
  startingPrice: 111,
  oracleUrl: '',
  collectionUrl: './mirrors.html',
  contactUrl: 'https://mirrorsbyviulet.com/pages/contact',
  artworkUrl: 'https://mirrorsbyviulet.com/products/letters-to-the-subconscious',
  heroLine: ['You were never the storm.', 'You were always the artist.'],
  detailViews: [
    { id: 'sea', label: 'The letters', title: 'What you carry.', description: 'Across the water, familiar stories. Some were given to you. Some are ready to be rewritten.', x: .28, y: .70, zoom: 1.9 },
    { id: 'cage', label: 'The cage', title: 'What feels familiar.', description: 'The beliefs that once protected you can become the boundaries of your world.', x: .51, y: .54, zoom: 1.6 },
    { id: 'light', label: 'The light', title: 'What is still yours.', description: 'Within the storm, a different world takes shape. The brush is still in your hand.', x: .555, y: .525, zoom: 3.3 }
  ]
};
